/* WL Ask — site-wide FAQ question box + corner Help launcher (v2 2026-07-31).
   Lazy-loads wl-faq-index.json (built from wl_faq/faq_data.py — single source
   of truth). Placement priority per page: FAQ hub = none; existing
   questions-heading = merge (replaces the heading, same line); #wl-ask-inline
   mount = inline; else footer bar.
   The launcher replaces Shopify Inbox: quick questions + FAQ search (no
   sign-in), live order tracking via worker /api/order-status, WhatsApp +
   email escalation. */
(function () {
  "use strict";
  if (window.__wlAskLoaded) return; window.__wlAskLoaded = true;

  var SYN = {ship:"ship",shipping:"ship",delivery:"ship",deliver:"ship",post:"ship",postage:"ship",freight:"ship",courier:"ship",send:"ship",
  price:"price",cost:"price",costs:"price",fee:"price",fees:"price",charge:"price",expensive:"price",cheap:"price",much:"price",pricing:"price",
  frame:"frame",framing:"frame",framed:"frame",frames:"frame",floater:"frame",floating:"frame",
  hang:"hang",hanging:"hang",install:"hang",installation:"hang",mount:"hang",mounting:"hang",hook:"hang",hooks:"hang",
  fade:"fade",fading:"fade",uv:"fade",sun:"fade",sunlight:"fade",fades:"fade",yellowing:"fade",lightfast:"fade",
  mural:"mural",murals:"mural",wallpaper:"mural",wallcovering:"mural",
  refund:"refund","return":"refund",returns:"refund",exchange:"refund",money:"refund",guarantee:"refund",warranty:"refund",
  photo:"image",photos:"image",image:"image",images:"image",picture:"image",pictures:"image",file:"image",files:"image",pic:"image",
  size:"size",sizes:"size",dimension:"size",dimensions:"size",big:"size",large:"size",huge:"size",oversize:"size",small:"size",wide:"size",tall:"size",
  time:"time",turnaround:"time","long":"time",fast:"time",quick:"time",when:"time",soon:"time",wait:"time",weeks:"time",days:"time",urgent:"time",deadline:"time",
  clean:"care",cleaning:"care",care:"care",dust:"care",maintain:"care",maintenance:"care",wipe:"care",
  canvas:"canvas",linen:"canvas",cotton:"canvas",synthetic:"canvas",fabric:"canvas",
  discount:"trade",trade:"trade",wholesale:"trade",designer:"trade",designers:"trade",architect:"trade",bulk:"trade",
  painting:"commission",commission:"commission",commissioned:"commission",bespoke:"commission",painted:"commission",
  certificate:"edition",authenticity:"edition",edition:"edition",editions:"edition",signed:"edition",numbered:"edition",limited:"edition",
  quality:"quality",giclee:"quality",dpi:"quality",resolution:"quality",res:"quality",sharp:"quality",blurry:"quality",pixelated:"quality",
  track:"track",tracking:"track",status:"track",
  colour:"colour",color:"colour",colours:"colour",colors:"colour",recolor:"colour",recolour:"colour",hue:"colour",palette:"colour",
  panel:"panel",panels:"panel",triptych:"panel",diptych:"panel",split:"panel",pieces:"panel",
  damage:"damage",damaged:"damage",broken:"damage",insurance:"damage",insured:"damage",
  pay:"pay",payment:"pay",afterpay:"pay",paypal:"pay",card:"pay",instalments:"pay",installments:"pay",gst:"pay",tax:"pay",
  sample:"sample",samples:"sample",swatch:"sample",proof:"sample",preview:"sample",
  copyright:"rights",rights:"rights",legal:"rights",license:"rights",licensing:"rights",permission:"rights",
  international:"intl",overseas:"intl",abroad:"intl",worldwide:"intl","export":"intl",uk:"intl",usa:"intl",europe:"intl",
  pickup:"pickup",collect:"pickup",collection:"pickup",
  gloss:"finish",matte:"finish",matt:"finish",satin:"finish",finish:"finish",glare:"finish",
  weight:"weight",heavy:"weight",kilo:"weight",kg:"weight",weigh:"weight",
  paper:"paper",silk:"paper",burlap:"paper",substrate:"paper",substrates:"paper",rice:"paper",
  artist:"artist",who:"artist",summer:"artist",jiang:"artist",studio:"artist",
  custom:"custom",customise:"custom",customize:"custom",personalised:"custom",personalized:"custom",
  stretch:"stretch",stretched:"stretch",stretcher:"stretch",rolled:"stretch",roll:"stretch",tube:"stretch"};
  var STOP = {the:1,a:1,an:1,is:1,are:1,"do":1,does:1,can:1,you:1,i:1,my:1,it:1,to:1,of:1,"in":1,on:1,"for":1,and:1,or:1,what:1,how:1,me:1,your:1,we:1,be:1,"with":1,at:1,"if":1,will:1,as:1,us:1,up:1,no:1,so:1,its:1,our:1};
  function norm(s){s=s.toLowerCase();try{s=s.normalize("NFD").replace(/[̀-ͯ]/g,"");}catch(e){}
    return s.replace(/[^a-z0-9\s]/g," ").split(/\s+/).filter(function(w){return w.length>1;});}
  function canon(w){if(STOP[w])return null;if(w.length>3&&w.slice(-1)==="s"&&SYN[w]===undefined){var st=w.slice(0,-1);if(SYN[st])return SYN[st];}return SYN[w]||w;}
  function toks(s){var o=[];norm(s).forEach(function(w){var c=canon(w);if(c)o.push(c);});return o;}
  function toksIx(s){var o={};norm(s).forEach(function(w){if(STOP[w])return;o[w]=1;var c=canon(w);if(c)o[c]=1;});return Object.keys(o);}
  function fuzzy(a,b){if(a===b)return true;if(Math.abs(a.length-b.length)>1||a.length<5)return false;
    var i=0,j=0,d=0;while(i<a.length&&j<b.length){if(a[i]===b[j]){i++;j++;continue;}d++;if(d>1)return false;
    if(a.length>b.length)i++;else if(b.length>a.length)j++;else{i++;j++;}}
    return d+(a.length-i)+(b.length-j)<=1;}
  function score(qt,it){var s=0;qt.forEach(function(t){var hit=0;
    it.tq.forEach(function(w){if(w===t)hit=Math.max(hit,3);else if(w.length>3&&t.length>3&&(w.indexOf(t)===0||t.indexOf(w)===0))hit=Math.max(hit,2);else if(fuzzy(w,t))hit=Math.max(hit,2);});
    if(!hit)it.tk.forEach(function(w){if(w===t||(w.length>3&&t.length>3&&w.indexOf(t)===0)||fuzzy(w,t))hit=Math.max(hit,2);});
    if(!hit)it.ta.forEach(function(w){if(w===t)hit=Math.max(hit,1);else if(fuzzy(w,t))hit=Math.max(hit,1);});
    s+=hit;});return s;}

  // ---- page context: boost answers relevant to the page the visitor is on ----
  function pageCtx(){
    var p=location.pathname;
    if(p.indexOf("print-stretch-and-frame")>-1||p.indexOf("service-standard-print")>-1||p.indexOf("service-custom-print")>-1)return "print";
    if(p.indexOf("wall-murals")>-1||p.indexOf("wl-custom-wall-mural")>-1||p.indexOf("wl-mural")>-1)return "mural";
    if(p.indexOf("service-original-commission")>-1||p.indexOf("custom-art-package")>-1||p.indexOf("service-digital-design")>-1||p.indexOf("service-curation")>-1||p.indexOf("service-catalogue-editing")>-1)return "service";
    if(p.indexOf("trade-program")>-1||p.indexOf("service-drop-shipping")>-1||p.indexOf("service-print-beyond-canvas")>-1||p.indexOf("commercial")>-1)return "trade";
    if(p.indexOf("/products/")===0)return "artwork";
    return "";
  }
  var CTXW={
    print:{ordering:1.35,shipping:1.35,images:1.35,materials:1.3,sizes:1.3,framing:1.2,services:0.6,trade:0.6,murals:0.55},
    artwork:{materials:1.3,framing:1.3,sizes:1.3,shipping:1.3,images:1.25,care:1.2,services:0.6,trade:0.6,murals:0.55},
    mural:{murals:1.5,shipping:1.2,sizes:1.1,services:0.6,trade:0.6},
    service:{services:1.4,shipping:1.15,images:1.1,murals:0.6,trade:0.7},
    trade:{trade:1.45,shipping:1.15,services:0.8,murals:0.7}
  };
  var CTX=pageCtx();
  function ctxWeight(cat){
    var m=CTXW[CTX];if(!m)return 1;
    return m[cat]||1;
  }

  var INDEX=null, FETCHING=false, QUEUE=[];
  function withIndex(cb){
    if(INDEX){cb(INDEX);return;}
    QUEUE.push(cb);
    if(FETCHING)return; FETCHING=true;
    var url=(window.__wlFaqIndexUrl)||"/cdn/shop/t/0/assets/wl-faq-index.json";
    fetch(url).then(function(r){return r.json();}).then(function(d){
      /* market filter (2026-08-01): index rows carry m=all/au/intl — only keep
         the visitor's market so intl shoppers never get AU-only answers */
      var cc=(window.Shopify&&Shopify.country)||"AU";
      var mk=(cc==="AU"||cc==="NZ")?"au":"intl";
      d=d.filter(function(it){var m=it.m||"all";return m==="all"||m===mk;});
      d.forEach(function(it){it.tq=toksIx(it.q);it.tk=toksIx(it.k||"");it.ta=toksIx(it.a.replace(/<[^>]+>/g," "));});
      INDEX=d;QUEUE.forEach(function(f){f(d);});QUEUE=[];
    }).catch(function(){FETCHING=false;});
  }

  // Deep fallback (2026-07-31): when the local lexical pass finds nothing, ask
  // the site-wide engine (worker /api/site-search, deep tier — same engine as
  // the header magnify). FAQ hits map back to local entries so they render as
  // native accordions; page/policy hits become link rows. cb([]) on any error.
  function deepAsk(q,ix,cb){
    try{
      fetch("https://wl-studio.wallliberation.workers.dev/api/site-search",{
        method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({q:q,deep:true})})
      .then(function(r){return r.json();})
      .then(function(d){
        var out=[];
        (d.docs||[]).forEach(function(doc){
          if(out.length>=3||!doc.id)return;
          if(doc.id.indexOf("faq:")===0){
            var id=doc.id.slice(4);
            for(var i=0;i<ix.length;i++){if(ix[i].id===id){out.push(ix[i]);return;}}
          }else if(doc.type==="page"||doc.type==="policy"||doc.type==="tool"){
            out.push({q:doc.title,a:esc(doc.snip||"")+' <a href="'+esc(doc.url)+'">Open \u2192</a>'});
          }
        });
        cb(out);
      }).catch(function(){cb([]);});
    }catch(e){cb([]);}
  }

  var CSS = "" +
  ".wlask{width:100%;max-width:820px;margin:0 auto;position:relative;text-align:left;box-sizing:border-box}" +
  ".wlask *{box-sizing:border-box}" +
  ".wlask__row{display:flex;align-items:stretch;gap:0;width:100%}" +
  ".wlask__label{display:flex;align-items:center;background:#1a1a1a!important;color:#fff!important;font-size:12px!important;font-weight:700;letter-spacing:.12em;text-transform:uppercase;padding:0 18px!important;white-space:nowrap;margin:0;flex:0 0 auto}" +
  ".wlask__input{flex:1 1 auto;min-width:0;width:100%!important;font-size:16px!important;line-height:1.4!important;padding:14px 16px!important;height:auto!important;border:1px solid #1a1a1a!important;border-left:none!important;background:#fff!important;color:#1a1a1a!important;border-radius:0;outline:none;margin:0!important}" +
  ".wlask__input:focus{border-color:#000!important}" +
  ".wlask__allq{display:flex;align-items:center;flex:0 0 auto;border:none!important;padding:0 4px 0 16px;font-size:11px!important;font-weight:600;letter-spacing:.1em;text-transform:uppercase;white-space:nowrap;text-decoration:underline!important;text-underline-offset:3px;color:#1a1a1a!important;background:transparent!important}" +
  ".wlask__allq:hover{opacity:.6}" +
  ".wlask__panel{display:none;border:1px solid rgba(0,0,0,.2);border-top:none;background:#fff;padding:4px 16px 12px}" +
  ".wlask__item{border-bottom:1px solid rgba(0,0,0,.08);padding:0}" +
  ".wlask__item summary{cursor:pointer;list-style:none;padding:9px 0;font-size:.84rem;font-weight:500;line-height:1.35}" +
  ".wlask__item summary::-webkit-details-marker{display:none}" +
  ".wlask__item div{font-size:.82rem;line-height:1.55;opacity:.9;padding:0 0 10px}" +
  ".wlask__item div a{text-decoration:underline}" +
  ".wlask--bar{max-width:100%;padding:34px 20px;border-top:1px solid rgba(0,0,0,.12)}" +
  ".wlask--bar .wlask__inner{max-width:720px;margin:0 auto}" +
  ".wlask--sec{margin:10px 0 6px;max-width:100%}" +
  ".wlask__mailnote{font-size:.82rem;line-height:1.5;padding:10px 0 8px}" +
  ".wlask__mailrow{display:flex;gap:0;margin:0 0 10px}" +
  ".wlask__mail{flex:1 1 auto;min-width:0;font-size:14px!important;padding:10px 12px!important;border:1px solid #1a1a1a!important;background:#fff!important;color:#1a1a1a!important;border-radius:0;outline:none;margin:0!important;height:auto!important}" +
  ".wlask__send{flex:0 0 auto;background:#1a1a1a!important;color:#fff!important;border:1px solid #1a1a1a!important;font-size:11px!important;font-weight:700;letter-spacing:.1em;text-transform:uppercase;padding:0 16px;cursor:pointer;border-radius:0}" +
  ".wlask__send:disabled{opacity:.5;cursor:default}" +
  ".wlask__sent{font-size:.84rem;padding:12px 0;font-weight:600}" +
  ".wlask__askmore{display:block;padding:8px 0 10px;font-size:.72rem;letter-spacing:.06em;text-transform:uppercase;text-decoration:underline;text-underline-offset:3px;color:#1a1a1a;background:none;border:none;cursor:pointer}" +
  ".wlask--inline .wlask__input{font-size:13px!important;padding:8px 12px!important}" +
  ".wlask--inline .wlask__label{font-size:10px!important;padding:0 12px!important;letter-spacing:.1em}" +
  ".wlask--inline .wlask__allq{font-size:10px!important;padding-left:12px}" +
  ".wlask--inline .wlask__item summary{font-size:.8rem;padding:7px 0}" +
  ".wlask--inline .wlask__item div{font-size:.78rem}" +
  "@media(max-width:640px){" +
   ".wlask__row{flex-wrap:wrap}" +
   ".wlask__input{padding:12px 12px!important}" +
   ".wlask__label{font-size:11px!important;padding:0 10px;letter-spacing:.08em}" +
   ".wlask__allq{flex:1 0 100%;border:none;justify-content:flex-end;padding:8px 2px 0;font-size:11px!important;background:transparent}" +
   ".wlask__allq:hover{opacity:.6}" +
   ".wlask--bar{padding:24px 12px}.wlask--sec{margin:8px 0 4px}" +
  "}";

  function esc(s){var d=document.createElement("div");d.textContent=s;return d.innerHTML;}

  function mailRowHTML(){
    return '<div class="wlask__mailrow"><input class="wlask__mail" type="email" autocomplete="email" placeholder="your@email.com" aria-label="Your email">'+
           '<button type="button" class="wlask__send">Send to Summer</button></div>';
  }
  function wireMail(panel,getQ){
    var btn=panel.querySelector(".wlask__send");if(!btn)return;
    var em=panel.querySelector(".wlask__mail");
    btn.onclick=function(){
      var v=(em.value||"").trim(),q=getQ();
      if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)){em.focus();em.style.borderColor="#8a2f2f";return;}
      btn.disabled=true;btn.textContent="Sending\u2026";
      // our own worker, not FormSubmit: it sends Summer a branded email whose
      // Reply-To is the customer, then harvests her reply into the FAQ (2026-08-01)
      fetch("https://wl-studio.wallliberation.workers.dev/api/faq-ask",{
        method:"POST",
        headers:{"Content-Type":"application/json","Accept":"application/json"},
        body:JSON.stringify({email:v,q:q,
          page:document.title,url:location.href.split("?")[0],src:"faq-widget",hp:""})})
      .then(function(r){return r.json();})
      .then(function(d){
        if(d&&d.ok){
          panel.querySelector(".wlask__mailrow").outerHTML='<div class="wlask__sent">Sent \u2713 \u2014 Summer replies to '+v.replace(/</g,"")+' within one business day.</div>';
        }else{throw new Error("fail");}
      })
      .catch(function(){
        btn.disabled=false;btn.textContent="Send to Summer";
        if(!panel.querySelector(".wlask__mailfail")){
          var n=document.createElement("div");n.className="wlask__mailnote wlask__mailfail";
          n.innerHTML='Could not send \u2014 please email <a href="mailto:summer@wallliberation.com.au">summer@wallliberation.com.au</a> directly.';
          panel.appendChild(n);}
      });
    };
  }
  function mount(host, mode){
    var bar=(mode==="bar");
    var wrap=document.createElement("div");
    wrap.className="wlask"+(bar?" wlask--bar":"")+(mode==="sec"?" wlask--sec":"")+(mode==="inline"?" wlask--inline":"");
    wrap.innerHTML=(bar?'<div class="wlask__inner">':"")+
      '<div class="wlask__row">'+
      '<span class="wlask__label">Ask anything</span>'+
      '<input class="wlask__input" type="search" placeholder="Type any question…" aria-label="Ask a question">'+
      '<a class="wlask__allq" href="/pages/faq">All questions</a>'+
      '</div><div class="wlask__panel"></div>'+(bar?"</div>":"");
    host.appendChild(wrap);
    var input=wrap.querySelector(".wlask__input"), panel=wrap.querySelector(".wlask__panel"),
        allq=wrap.querySelector(".wlask__allq"), deb;
    function render(list,q){
      allq.setAttribute("href", q ? "/pages/faq?q="+encodeURIComponent(q) : "/pages/faq");
      if(!q){panel.style.display="none";panel.innerHTML="";return;}
      var h="";
      list.slice(0,3).forEach(function(it){
        h+='<details class="wlask__item"><summary>'+esc(it.q)+"</summary><div>"+it.a+"</div></details>";
      });
      if(!list.length){
        h+='<div class="wlask__mailnote"><strong>No answer for this yet.</strong> Leave your email and your question goes straight to the artist — replies within one business day.</div>'+mailRowHTML();
      }else{
        h+='<button type="button" class="wlask__askmore">Didn\u2019t find it? Ask by email</button><div class="wlask__askwrap" style="display:none">'+mailRowHTML()+'</div>';
      }
      panel.innerHTML=h;panel.style.display="block";
      var first=panel.querySelector(".wlask__item");if(first)first.open=true;
      var more=panel.querySelector(".wlask__askmore");
      if(more){more.onclick=function(){var ww=panel.querySelector(".wlask__askwrap");
        ww.style.display=ww.style.display==="none"?"":"none";};}
      wireMail(panel,function(){return input.value.trim();});
    }
    // Demand log (Summer 2026-08-13, /report build): what people actually TYPE
    // into the FAQ box. Locally-answered queries never reach the worker, so the
    // demand was invisible. Log the settled query (1.4 s pause) + hit count to
    // the clog feed — no visitor IDs, max 6 per page view, dedupe extensions.
    var ftDeb,ftLast="",ftN=0;
    function ftLog(q,n){
      clearTimeout(ftDeb);
      ftDeb=setTimeout(function(){try{
        if(q.length<4||ftN>=6)return;
        if(ftLast&&(q.indexOf(ftLast)===0||ftLast.indexOf(q)===0)&&ftLast!==q)ftN--; // extension of last — refine, don't double-count
        if(q===ftLast)return;
        ftLast=q;ftN++;
        var body=JSON.stringify({step:"faq-typed",q:q.slice(0,120),n:n,
          pg:location.pathname.slice(0,120)});
        // keepalive fetch, not sendBeacon — beacons force credentials-include,
        // which the worker's wildcard CORS rejects (live-tested 2026-08-13)
        fetch("https://wl-studio.wallliberation.workers.dev/api/clog",{method:"POST",keepalive:true,headers:{"content-type":"application/json"},body:body}).catch(function(){});
      }catch(e){}},1400);
    }
    input.addEventListener("input",function(){
      clearTimeout(deb);
      deb=setTimeout(function(){
        var q=input.value.trim();
        if(!q){render([],"");return;}
        withIndex(function(ix){
          var qt=toks(q);if(!qt.length){render([],"");return;}
          var scored=[],best=0;
          ix.forEach(function(it){var s=score(qt,it);if(s>=2)s=s*ctxWeight(it.c);if(s>best)best=s;if(s>=2)scored.push([s,it]);});
          var cut=Math.max(2,best*0.6);
          scored=scored.filter(function(x){return x[0]>=cut;}).sort(function(a,b){return b[0]-a[0];}).map(function(x){return x[1];});
          render(scored,q);
          ftLog(q,scored.length);
          if(!scored.length&&q.length>3){
            deepAsk(q,ix,function(found){
              if(found.length&&input.value.trim()===q)render(found,q);
            });
          }
        });
      },160);
    });
    input.addEventListener("focus",function(){withIndex(function(){});});
    // the widget can sit inside the product's add-to-cart form — Enter must never submit it
    wrap.addEventListener("keydown",function(e){
      if(e.key==="Enter"){
        e.preventDefault();e.stopPropagation();
        var t=e.target;
        if(t&&t.classList&&t.classList.contains("wlask__mail")){
          var sb=wrap.querySelector(".wlask__send");if(sb)sb.click();
        }
      }
    },true);
    document.addEventListener("keydown",function(e){if(e.key==="Escape"){panel.style.display="none";}});
  }

  var HEADINGS = {"common questions":1,"faq":1,"faqs":1,"frequently asked questions":1};
  function faqHeading(){
    var hs=document.querySelectorAll("h2,h3");
    for(var i=0;i<hs.length;i++){
      var x=hs[i].textContent.trim().toLowerCase().replace(/\s+/g," ");
      if(HEADINGS[x]||x.indexOf("questions")===0)return hs[i];
    }
    return null;
  }

  function place(){
    if(document.getElementById("wlfaqSearch"))return;           // FAQ hub — has its own search
    if(document.querySelector(".wlask"))return;                  // already placed
    var inline=document.getElementById("wl-ask-inline");
    if(inline){                                                  // product-template mount: under add-to-cart
      var btn=document.querySelector('form[action*="/cart/add"] button[type="submit"],button[name="add"]');
      var blk=btn?(btn.closest('[class*="buy-buttons"]')||btn.closest('form')):null;
      if(blk){
        // prefer inserting under a short text paragraph that directly follows add-to-cart
        var blkRect=blk.getBoundingClientRect(),anchorEl=null;
        var proses=document.querySelectorAll(".prose");
        for(var i=0;i<proses.length;i++){
          var el=proses[i];
          if(!(blk.compareDocumentPosition(el)&Node.DOCUMENT_POSITION_FOLLOWING))continue;
          if(el.querySelector("form,button,details,input,select"))continue;
          if((el.textContent||"").trim().length>340)continue;
          var r=el.getBoundingClientRect();
          if(r.top>=blkRect.bottom-4&&r.top-blkRect.bottom<220){anchorEl=el;break;}
          if(r.top-blkRect.bottom>=220)break;
        }
        if(!anchorEl){
          var node=blk;
          while(node&&!node.nextElementSibling&&node.parentElement&&node.parentElement.tagName!=="BODY")node=node.parentElement;
          anchorEl=node;
        }
        // WL 2026-07-31 (Summer): the set-discount promo owns the slot DIRECTLY
        // under Add to cart — the ask box must never wedge between them. When the
        // promo follows the anchor, the ask box drops below the promo instead.
        var sp=document.querySelector(".wl-setpromo--pdp");
        if(sp&&anchorEl&&(anchorEl===sp||anchorEl.contains(sp)||(anchorEl.compareDocumentPosition(sp)&Node.DOCUMENT_POSITION_FOLLOWING&&sp.getBoundingClientRect().top-anchorEl.getBoundingClientRect().bottom<260)))anchorEl=sp;
        var box=document.createElement("div");
        box.style.margin="14px 0 2px";
        anchorEl.insertAdjacentElement("afterend",box);
        mount(box,"inline");
      }else{
        mount(inline,"inline");
      }
      return;
    }
    var fh=faqHeading();
    if(fh){                                                      // merge into existing questions section
      // insert into the exact container of the first question that follows the heading,
      // so the box shares its width precisely (heading may live in its own wrapper div)
      var all=document.querySelectorAll("details"),target=null;
      for(var i=0;i<all.length;i++){
        if(fh.compareDocumentPosition(all[i])&Node.DOCUMENT_POSITION_FOLLOWING){target=all[i];break;}
      }
      var host;
      if(target){
        var cont=target.parentElement;
        if(cont.tagName==="OL"||cont.tagName==="UL"){
          host=document.createElement("li");
          host.style.listStyle="none";host.style.margin="0 0 10px";
        }else{
          host=document.createElement("div");
          host.style.margin="0 0 12px";
        }
        host.style.gridColumn="1 / -1";host.style.width="100%";
        cont.insertBefore(host,target);
      }else{
        host=document.createElement("div");
        fh.parentNode.insertBefore(host,fh);
      }
      fh.parentNode.removeChild(fh);
      mount(host,"sec");
      return;
    }
    var anchor=document.querySelector('[id^="shopify-section"][id*="footer"]');
    var bar=document.createElement("div");
    if(anchor&&anchor.parentNode){anchor.parentNode.insertBefore(bar,anchor);}else{document.body.appendChild(bar);}
    mount(bar,"bar");                                            // everything else
  }

  /* ============ WL Help launcher — replaces Shopify Inbox ============ */
  var OLIVE="#425934", WORKER="https://wl-studio.wallliberation.workers.dev";
  var WA="https://wa.me/61457189768", PH="0457 189 768";
  // quick questions = the same set Summer ran in Shopify Inbox; ids point into
  // the FAQ index so question AND answer text stay single-sourced from faq_data.py
  var QUICK=["turnaround","file-requirements","max-size","shipping-cost","discounts","colour-editing"];

  var HCSS = "" +
  ".wlassist{font-size:16px;line-height:1.4;color:#1a1a1a}" +
  ".wlassist *{box-sizing:border-box}" +
  /* header icon (Summer 2026-07-31: chat lives in the top bar before search/cart,
     never floats over artwork) — matches the theme's line-icon row */
  ".wlassist-hli{display:flex;align-items:center}" +
  /* 4 icons fill the header's right column almost exactly at tablet widths —
     without this the cluster breaks onto a 2nd row */
  "header .header__secondary-nav{flex-wrap:nowrap!important}" +
  /* Summer 2026-07-31: line icon was too blended in — olive circle (original
     bubble look) with the WhatsApp glyph, mini size so the header stays calm */
  ".wlassist-hli button{width:34px;height:34px;border-radius:50%;background:"+OLIVE+";color:#fff;border:none;cursor:pointer;padding:0;margin:0;display:flex;align-items:center;justify-content:center;box-shadow:0 1px 4px rgba(0,0,0,.18)}" +
  ".wlassist-hli button:hover{filter:brightness(1.12)}" +
  ".wlassist-hli svg{width:19px;height:19px;display:block}" +
  /* floating bubble kept ONLY as fallback if the header slot ever disappears */
  ".wlassist__btn{position:fixed;right:18px;bottom:18px;z-index:9990;width:54px;height:54px;border-radius:50%;background:"+OLIVE+";color:#fff;border:none;cursor:pointer;box-shadow:0 4px 14px rgba(0,0,0,.25);display:flex;align-items:center;justify-content:center;padding:0}" +
  ".wlassist__btn svg{width:26px;height:26px;display:block}" +
  ".wlassist__panel{position:fixed;right:14px;top:var(--wlatop,108px);z-index:9991;width:344px;max-width:calc(100vw - 24px);background:#fff;border:1px solid rgba(0,0,0,.18);box-shadow:0 10px 34px rgba(0,0,0,.22);display:flex;flex-direction:column;max-height:calc(100vh - var(--wlatop,108px) - 18px)}" +
  ".wlassist__head{background:"+OLIVE+";color:#fff;padding:16px 18px 13px}" +
  ".wlassist__title{font-weight:600;font-size:.95rem;line-height:1.35;margin:0}" +
  ".wlassist__sub{font-size:.72rem;letter-spacing:.05em;opacity:.85;margin-top:3px}" +
  ".wlassist__body{overflow-y:auto;padding:12px 14px;flex:1 1 auto;-webkit-overflow-scrolling:touch}" +
  ".wlassist__srow{display:flex;border:1px solid #1a1a1a}" +
  ".wlassist__sin{flex:1 1 auto;min-width:0;border:none!important;outline:none;font-size:16px!important;padding:11px 12px!important;background:#fff!important;color:#1a1a1a!important;margin:0!important;height:auto!important;border-radius:0}" +
  ".wlassist__results{margin:2px 0 4px}" +
  ".wlassist__results .wlask__item div{font-size:.8rem}" +
  ".wlassist__results .wlask__item summary{font-size:.82rem}" +
  ".wlassist__sec{font-size:.68rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;opacity:.55;margin:14px 0 4px}" +
  ".wlassist__q{display:block;width:100%;text-align:left;background:none;border:none;border-bottom:1px solid rgba(0,0,0,.08);cursor:pointer;font-size:.82rem;line-height:1.35;padding:8px 2px;color:#1a1a1a}" +
  ".wlassist__q:hover{color:"+OLIVE+"}" +
  ".wlassist__track{display:block;width:100%;text-align:left;background:none;border:none;border-bottom:1px solid rgba(0,0,0,.08);cursor:pointer;font-size:.82rem;font-weight:600;line-height:1.35;padding:8px 2px;color:#1a1a1a}" +
  ".wlassist__track:hover{color:"+OLIVE+"}" +
  ".wlassist__tform{padding:8px 0 4px}" +
  ".wlassist__tin{width:100%;font-size:16px!important;padding:10px 12px!important;border:1px solid #1a1a1a!important;background:#fff!important;color:#1a1a1a!important;border-radius:0;outline:none;margin:0 0 8px!important;height:auto!important}" +
  ".wlassist__tgo{width:100%;background:#1a1a1a;color:#fff;border:1px solid #1a1a1a;font-size:11px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;padding:11px 16px;cursor:pointer;border-radius:0}" +
  ".wlassist__tgo:disabled{opacity:.5;cursor:default}" +
  ".wlassist__tres{font-size:.82rem;line-height:1.55;padding:10px 2px 2px}" +
  ".wlassist__tres a{text-decoration:underline;color:#1a1a1a}" +
  ".wlassist__stage{font-weight:700}" +
  ".wlassist__foot{border-top:1px solid rgba(0,0,0,.12);padding:11px 14px 12px;background:#fafaf8}" +
  ".wlassist__still{font-size:.68rem;font-weight:700;letter-spacing:.12em;text-transform:uppercase;opacity:.55;margin:0 0 7px}" +
  ".wlassist__crow{display:flex;gap:8px}" +
  ".wlassist__wa,.wlassist__em{flex:1 1 50%;display:flex;align-items:center;justify-content:center;gap:7px;font-size:.78rem;font-weight:600;padding:10px 6px;border:1px solid #1a1a1a;text-decoration:none;color:#1a1a1a;background:#fff;cursor:pointer;border-radius:0}" +
  ".wlassist__wa{background:"+OLIVE+";border-color:"+OLIVE+";color:#fff}" +
  ".wlassist__wa:hover{filter:brightness(1.08)}.wlassist__em:hover{background:#f0f0ec}" +
  ".wlassist__wa svg{width:15px;height:15px}" +
  ".wlassist__ph{font-size:.72rem;opacity:.6;margin-top:8px;text-align:center}" +
  ".wlassist__ph a{color:#1a1a1a;text-decoration:none}" +
  ".wlassist__mailwrap{margin-top:8px}" +
  "@media(max-width:640px){" +
   /* phone: same cluster and same order as desktop. The header's right grid
      column auto-sizes, but the theme's 14.4px icon gap makes the icons wrap to
      a 2nd row. 2026-07-31 (Summer): 2px, matching wl-overrides — the bigger
      100px logo needs the icon block ≤110px; the old 6px here overrode it. */
   ".wlassist-hli button{width:22px;height:22px;box-shadow:none}" +
   ".wlassist-hli svg{width:13px;height:13px}" +
   "header .header__secondary-nav{gap:2px!important}" +
   ".wlassist__btn{width:50px;height:50px;right:12px;bottom:calc(12px + env(safe-area-inset-bottom,0px))}" +
   ".wlassist__panel{left:10px;right:10px;top:auto;bottom:calc(10px + env(safe-area-inset-bottom,0px));width:auto;max-height:72vh}" +
  "}";

  var ICON_CHAT='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>';
  var ICON_X='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';
  var ICON_WA='<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.5 14.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.96-.94 1.16-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5 0 1.47 1.07 2.9 1.22 3.1.15.2 2.1 3.2 5.08 4.49.71.3 1.26.49 1.7.63.71.22 1.36.19 1.87.11.57-.08 1.76-.72 2-1.41.25-.7.25-1.29.18-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.8h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.85 9.85 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.9-9.88a9.83 9.83 0 0 1 7 2.9 9.83 9.83 0 0 1 2.9 7c0 5.45-4.45 9.87-9.9 9.87zm8.42-18.3A11.8 11.8 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.9c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.9 11.9 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.9 0-3.18-1.24-6.16-3.47-8.4z"/></svg>';

  function stageLine(d){
    var s=(d.stage||"").toUpperCase(), out;
    if(s==="FULFILLED")out='<span class="wlassist__stage">Shipped</span>';
    else if(s==="PARTIALLY_FULFILLED")out='<span class="wlassist__stage">Partially shipped</span>';
    else out='<span class="wlassist__stage">In production</span> — rolled ships in 1–2 weeks, stretched or framed in 2–3 weeks from order.';
    return out;
  }
  function fmtDate(iso){
    try{return new Date(iso).toLocaleDateString("en-AU",{day:"numeric",month:"short",year:"numeric"});}
    catch(e){return (iso||"").slice(0,10);}
  }
  // header icon = the ONE launcher (Summer 2026-07-31). Recreated whenever the
  // theme re-renders the header; falls back to a floating bubble only if the
  // header slot is gone entirely.
  function ensureHelpBtn(){
    var root=document.querySelector(".wlassist");
    if(!root||!root.__wlaToggle)return;
    // 2026-07-31: the header li is server-rendered in sections/header.liquid so
    // it paints with the page (no late pop-in on cold mobile loads) — here we
    // only wire the click. JS injection below stays as fallback for templates
    // that render a header without the li.
    var ex=document.querySelector(".wlassist-hli button,.wlassist__btn");
    if(ex){
      if(!ex.__wlaBound){ex.__wlaBound=true;ex.onclick=function(){root.__wlaToggle();};}
      return;
    }
    // FIRST in the icon cluster on every screen (Summer 2026-07-31: same place
    // desktop and phone). Account link is hidden on phones by the theme, so
    // anchoring to it still renders our button first there.
    var slot=document.querySelector("header .header__account-link")
          || document.querySelector("header .header__search-link");
    var btn=document.createElement("button");
    btn.type="button";btn.setAttribute("aria-label","Help and questions");
    btn.setAttribute("aria-expanded",panelOpen()?"true":"false");
    btn.innerHTML=panelOpen()?ICON_X:ICON_WA;
    btn.onclick=function(){root.__wlaToggle();};
    if(slot){
      var li=document.createElement("li");
      li.className="wlassist-hli";
      li.appendChild(btn);
      slot.parentElement.insertBefore(li,slot);
    }else{
      btn.className="wlassist__btn";
      document.body.appendChild(btn);
    }
    function panelOpen(){var p=document.querySelector(".wlassist__panel");return p&&!p.hasAttribute("hidden");}
  }
  function helpMount(){
    if(document.querySelector(".wlassist")){ensureHelpBtn();return;}
    var root=document.createElement("div");
    root.className="wlassist";
    root.innerHTML=
      '<div class="wlassist__panel" hidden>'+
        '<div class="wlassist__head"><p class="wlassist__title">Welcome to Wall Liberation — how can I help?</p>'+
        '<div class="wlassist__sub">Instant answers · no sign-in needed</div></div>'+
        '<div class="wlassist__body">'+
          '<div class="wlassist__srow"><input class="wlassist__sin" type="search" placeholder="Type any question…" aria-label="Ask a question"></div>'+
          '<div class="wlassist__results"></div>'+
          '<div class="wlassist__sec">Your order</div>'+
          '<button type="button" class="wlassist__track">Track my order</button>'+
          '<div class="wlassist__tform" hidden>'+
            '<input class="wlassist__tin wlassist__tord" inputmode="numeric" placeholder="Order number — e.g. 1234" aria-label="Order number">'+
            '<input class="wlassist__tin wlassist__tem" type="email" autocomplete="email" placeholder="Email used on the order" aria-label="Order email">'+
            '<button type="button" class="wlassist__tgo">Check status</button>'+
            '<div class="wlassist__tres"></div>'+
          '</div>'+
          '<div class="wlassist__sec">Common questions</div>'+
          '<div class="wlassist__quick"></div>'+
        '</div>'+
        '<div class="wlassist__foot">'+
          '<div class="wlassist__still">Still need help?</div>'+
          '<div class="wlassist__crow">'+
            '<a class="wlassist__wa" target="_blank" rel="noopener">'+ICON_WA+'WhatsApp</a>'+
            '<button type="button" class="wlassist__em">Email Summer</button>'+
          '</div>'+
          '<div class="wlassist__mailwrap" style="display:none"></div>'+
          '<div class="wlassist__ph">Ph: <a href="tel:+61457189768">'+PH+'</a> · Mon–Fri 9–5</div>'+
        '</div>'+
      '</div>';
    document.body.appendChild(root);

    var panel=root.querySelector(".wlassist__panel"),
        sin=root.querySelector(".wlassist__sin"), res=root.querySelector(".wlassist__results"),
        quick=root.querySelector(".wlassist__quick"), tbtn=root.querySelector(".wlassist__track"),
        tform=root.querySelector(".wlassist__tform"), tres=root.querySelector(".wlassist__tres");

    function allBtns(){return document.querySelectorAll(".wlassist-hli button,.wlassist__btn");}
    function setIcons(open){
      allBtns().forEach(function(b){b.innerHTML=open?ICON_X:ICON_WA;b.setAttribute("aria-expanded",open?"true":"false");});
    }
    function setTop(){
      // dropdown sits under the sticky header; fall back to a sane offset
      var h=document.querySelector("header");
      var b=h?h.getBoundingClientRect().bottom:0;
      root.style.setProperty("--wlatop",Math.max(56,Math.min(b+10,200))+"px");
    }
    function togglePanel(){
      var open=panel.hasAttribute("hidden");
      if(open){
        setTop();panel.removeAttribute("hidden");setIcons(true);
        withIndex(function(ix){
          if(quick.childElementCount)return;
          QUICK.forEach(function(id){
            var it=null;ix.forEach(function(x){if(x.id===id)it=x;});
            if(!it)return;
            var b=document.createElement("button");
            b.type="button";b.className="wlassist__q";b.textContent=it.q;
            b.onclick=function(){
              res.innerHTML='<details class="wlask__item" open><summary>'+esc(it.q)+'</summary><div>'+it.a+'</div></details>';
              res.scrollIntoView({block:"nearest"});
            };
            quick.appendChild(b);
          });
        });
      }else{panel.setAttribute("hidden","");setIcons(false);}
    }
    root.__wlaToggle=togglePanel;
    document.addEventListener("keydown",function(e){
      if(e.key==="Escape"&&!panel.hasAttribute("hidden")){panel.setAttribute("hidden","");setIcons(false);}
    });
    document.addEventListener("mousedown",function(e){
      if(panel.hasAttribute("hidden"))return;
      if(root.contains(e.target))return;
      var t=e.target.closest&&e.target.closest(".wlassist-hli,.wlassist__btn");
      if(t)return;
      panel.setAttribute("hidden","");setIcons(false);
    });

    // search — same index, scoring and context weighting as the inline ask box
    var deb;
    sin.addEventListener("input",function(){
      clearTimeout(deb);
      deb=setTimeout(function(){
        var q=sin.value.trim();
        if(!q){res.innerHTML="";return;}
        withIndex(function(ix){
          var qt=toks(q);if(!qt.length){res.innerHTML="";return;}
          if(qt.indexOf("track")>-1){tform.removeAttribute("hidden");}
          var scored=[],best=0;
          ix.forEach(function(it){var s=score(qt,it);if(s>=2)s=s*ctxWeight(it.c);if(s>best)best=s;if(s>=2)scored.push([s,it]);});
          var cut=Math.max(2,best*0.6);
          scored=scored.filter(function(x){return x[0]>=cut;}).sort(function(a,b){return b[0]-a[0];}).map(function(x){return x[1];});
          var h="";
          scored.slice(0,3).forEach(function(it){
            h+='<details class="wlask__item"><summary>'+esc(it.q)+'</summary><div>'+it.a+'</div></details>';
          });
          if(!scored.length)h='<div class="wlask__mailnote"><strong>No answer for this yet.</strong> Reach Summer below — replies within one business day.</div>';
          res.innerHTML=h;
          var first=res.querySelector(".wlask__item");if(first)first.open=true;
          if(!scored.length&&q.length>3){
            deepAsk(q,ix,function(found){
              if(!found.length||sin.value.trim()!==q)return;
              var h2="";
              found.forEach(function(it){h2+='<details class="wlask__item"><summary>'+esc(it.q)+'</summary><div>'+it.a+'</div></details>';});
              res.innerHTML=h2;
              var f2=res.querySelector(".wlask__item");if(f2)f2.open=true;
            });
          }
        });
      },160);
    });
    sin.addEventListener("keydown",function(e){if(e.key==="Enter")e.preventDefault();});

    // order tracking
    tbtn.onclick=function(){
      if(tform.hasAttribute("hidden")){tform.removeAttribute("hidden");root.querySelector(".wlassist__tord").focus();}
      else tform.setAttribute("hidden","");
    };
    root.querySelector(".wlassist__tgo").onclick=function(){
      var go=this, ord=root.querySelector(".wlassist__tord").value.trim(),
          em=root.querySelector(".wlassist__tem").value.trim();
      if(!ord||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em)){tres.innerHTML="Enter your order number and the email you ordered with.";return;}
      go.disabled=true;go.textContent="Checking…";tres.innerHTML="";
      fetch(WORKER+"/api/order-status",{method:"POST",headers:{"Content-Type":"application/json"},
        body:JSON.stringify({order:ord,email:em})})
      .then(function(r){return r.json().then(function(d){d.__http=r.status;return d;});})
      .then(function(d){
        go.disabled=false;go.textContent="Check status";
        if(d.__http===429){tres.innerHTML="Too many lookups from this connection today — please WhatsApp or email us below.";return;}
        if(!d.ok){tres.innerHTML="Could not check just now — please try again, or reach us below.";return;}
        if(!d.found){tres.innerHTML="No order matches that number and email. Check both against your confirmation email, or reach us below.";return;}
        var h="<strong>Order "+esc(d.name)+"</strong> · placed "+esc(fmtDate(d.placed))+"<br>"+stageLine(d);
        (d.tracking||[]).forEach(function(t){
          h+="<br>"+esc(t.company||"Tracking")+": "+(t.url?'<a href="'+esc(t.url)+'" target="_blank" rel="noopener">'+esc(t.number)+"</a>":esc(t.number));
        });
        if(d.status_url)h+='<br><a href="'+esc(d.status_url)+'" target="_blank" rel="noopener">Full order details ↗</a>';
        tres.innerHTML=h;
      })
      .catch(function(){go.disabled=false;go.textContent="Check status";
        tres.innerHTML="Could not check just now — please try again, or reach us below.";});
    };

    // escalation: WhatsApp prefilled with the page they're on; email = existing relay
    var waMsg="Hi Summer, I’m on "+location.href.split("?")[0]+" — ";
    root.querySelector(".wlassist__wa").href=WA+"?text="+encodeURIComponent(waMsg);
    var emBtn=root.querySelector(".wlassist__em"), mw=root.querySelector(".wlassist__mailwrap");
    emBtn.onclick=function(){
      if(mw.style.display==="none"){
        mw.style.display="";
        if(!mw.innerHTML){
          mw.innerHTML=mailRowHTML();
          wireMail(mw,function(){return sin.value.trim()||"(no question typed — sent from help widget)";});
        }
      }else mw.style.display="none";
    };

    ensureHelpBtn();
  }

  var ensureTimer=null;
  function init(){
    var st=document.createElement("style");st.textContent=CSS+HCSS;document.head.appendChild(st);
    place();
    helpMount();
    // theme re-renders sections after load and can wipe the mount — self-heal
    try{
      new MutationObserver(function(){
        clearTimeout(ensureTimer);
        ensureTimer=setTimeout(function(){place();helpMount();},200);
      }).observe(document.body,{childList:true,subtree:true});
    }catch(e){}
  }
  if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",init);}else{init();}
})();
